import React, { useEffect } from "react";
import Preloader from "../helper/Preloader.jsx";
import HeaderTwo from "../components/HeaderTwo.jsx";
import BannerTwo from "../components/BannerTwo.jsx";
import PromotionalTwo from "../components/PromotionalTwo.jsx";
import DealsOne from "../components/DealsOne.jsx";
import TopSellingOne from "../components/TopSellingOne.jsx";
import TrendingOne from "../components/TrendingOne.jsx";
import DiscountOne from "../components/DiscountOne.jsx";
import FeaturedOne from "../components/FeaturedOne.jsx";
import BigDealOne from "../components/BigDealOne.jsx";
import TopSellingTwo from "../components/TopSellingTwo.jsx";
import PopularProductsOne from "../components/PopularProductsOne.jsx";
import TopVendorsTwo from "../components/TopVendorsTwo.jsx";
import DaySaleOne from "../components/DaySaleOne.jsx";
import RecentlyViewedOne from "../components/RecentlyViewedOne.jsx";
import BrandTwo from "../components/BrandTwo.jsx";
import ShippingTwo from "../components/ShippingTwo.jsx";
import NewsletterTwo from "../components/NewsletterTwo.jsx";
import FooterTwo from "../components/FooterTwo.jsx";
import BottomFooter from "../components/BottomFooter.jsx";
import ColorInit from "../helper/ColorInit.jsx";
import ScrollToTop from "react-scroll-to-top";
import { useAuth } from "../context/AuthContext.jsx";
import { useDispatch } from "react-redux";
import { fetchCoupons, fetchTopTwoCoupons } from "../state/slices/couponSlice.js";

const HomePage = () => {
  const dispatch = useDispatch();
  const { user, token, isAuthenticated } = useAuth();

  useEffect(() => {
    dispatch(fetchCoupons());
    dispatch(fetchTopTwoCoupons());
  }, [dispatch]);

  return (

    <>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      <HeaderTwo category={false} />

      {/* BannerTwo */}
      <BannerTwo />

      {/* PromotionalTwo */}
      <PromotionalTwo />

      {/* DealsOne */}
      <DealsOne />

      {/* TopSellingOne */}
      <TopSellingOne />

      {/* TrendingOne */}
      <TrendingOne />

      {/* BigDealOne */}
      {/* <BigDealOne /> */}

      {/* DiscountOne */}
      {/* <DiscountOne /> */}

      {/* FeaturedOne */}
      {/* <FeaturedOne /> */}

      {/* TopSellingTwo */}
      <TopSellingTwo />

      {/* PopularProductsOne */}
      {/* <PopularProductsOne /> */}

      {/* TopVendorsTwo */}
      {/* <TopVendorsTwo /> */}

      {/* DaySaleOne */}
      {/* <DaySaleOne /> */}

      {/* RecentlyViewedOne */}
      <RecentlyViewedOne />

      {/* BrandTwo */}
      {/* <BrandTwo /> */}

      {/* ShippingTwo */}
      {/* <ShippingTwo /> */}

      {/* NewsletterTwo */}
      <NewsletterTwo />

      {/* FooterTwo */}
      <FooterTwo />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default HomePage;
